<section id="skills" class="content">
    <div class="wrapper">
        <h2>I’m pretty talented, <br/>just ask my mother.</h2>
        <p>
            I’ve been messing around with the web for as long as I can remember.
            Even after all these years I’m still just as fascinated with the ever evolving landscape of web, design, and
            software engineering.
        </p>
        <p>
            I define myself as a <em>Product Engineer</em>. I like to think beyond just frontend design and backend engineering,
            instead taking a holistic and consumer-focused approach to everything I make.
        </p>
<!--        <p>-->
<!--            When I say I'm full-stack, I really mean I’m <em>full stack</em>. My personal passion is frontend design and-->
<!--            development, my core skills are with backend engineering and optimisation, and I spent the better half of my-->
<!--            degree and early career specialising in data storage, processing, and analytics.-->
<!--        </p>-->
        <p>
            As well as being a talented nerd, my mum also says I’m <q>pretty cool</q>.
        </p>
    </div>
</section>